module.exports = __webpack_public_path__ + "img/icon-DoNotStretch-cc.407fb710.png";